//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ICollectionFiltersDto } from '@apis/collections/ICollectionFiltersDto';
import { IFilters } from '@streams/models/assetFeedsModalStateModel';
import { StreamsDrawerStreamType, StreamsLaunchContext } from '@streams-drawer/streams-drawer-constants';
import { parseDateRangeStringFromFilter } from '@utils/dateUtils';

// Note: this function only converts the filters necessary for google asset feeds.
export const sidebarFiltersToAssetFeedCollectionFilters = (filters: IFilters): ICollectionFiltersDto => {
  return {
    ...(filters.rightsStatuses && {
      rights: { options: [...filters.rightsStatuses] }
    }),
    ...(filters.mediaItemTypes && {
      mediaTypes: { options: [...filters.mediaItemTypes] }
    }),
    ...(filters.labels && {
      labels: { options: [...filters.labels] }
    }),
    ...(filters.dateRange && filters.dateRange[0] && {
      dateRange: parseDateRangeStringFromFilter(filters.dateRange[0])
    }),
    ...(filters.spamFiltering && {
      spam: filters.spamFiltering[0] === 'true',
    }),
    ...((filters.minHeight || filters.maxHeight) && {
      height: {
        ...(filters.minHeight && filters.minHeight.length > 0 && {
          min: filters.minHeight[0]
        }),
        ...(filters.maxHeight && filters.maxHeight.length > 0 && {
          max: filters.maxHeight[0]
        }),
      }
    }),
    ...((filters.minWidth || filters.maxWidth) && {
      width: {
        ...(filters.minWidth && filters.minWidth.length > 0 && {
          min: filters.minWidth[0]
        }),
        ...(filters.maxWidth && filters.maxWidth.length > 0 && {
          max: filters.maxWidth[0]
        }),
      }
    }),
    ...((filters.minAspectRatio || filters.maxAspectRatio) && {
      aspectRatio: {
        ...(filters.minAspectRatio && filters.minAspectRatio.length > 0 && {
          min: filters.minAspectRatio[0]
        }),
        ...(filters.maxAspectRatio && filters.maxAspectRatio.length > 0 && {
          max: filters.maxAspectRatio[0]
        }),
      }
    }),
    ...(
      (
        filters.excludeMatchedMisItemForInstagramPost &&
        filters.excludeMatchedMisItemForInstagramPost.length > 0
      ) || (
        filters.excludeOriginalRepostedInstagramItem &&
        filters.excludeOriginalRepostedInstagramItem.length > 0
      ) || (
        filters.excludeMatchedInstagramItemForInstagramStory &&
        filters.excludeMatchedInstagramItemForInstagramStory.length > 0
      )
    ) && {
      duplicateItemExclusions: {
        excludeMatchedMisItemForInstagramPost: filters.excludeMatchedMisItemForInstagramPost[0] === 'true',
        excludeOriginalRepostedInstagramItem: filters.excludeOriginalRepostedInstagramItem[0] === 'true',
               excludeMatchedInstagramItemForInstagramStory: filters.excludeMatchedInstagramItemForInstagramStory[0] === 'true',
      }
    },
    ...(filters.excludedContentSources && filters.excludedContentSources.length > 0 && {
      excludedContentSources: filters.excludedContentSources
    })
  };
};

export const getStreamsDrawerLayout = (
  selectedStreamType: StreamsDrawerStreamType,
  contentView: string,
  launchContext: string,
) => {
  if (
    selectedStreamType === StreamsDrawerStreamType.TAGGED_BY_CURALTE ||
    selectedStreamType === StreamsDrawerStreamType.CONNECT
  ) {
    return 'list';
  } else if (
    selectedStreamType === StreamsDrawerStreamType.SUMMARY
  ) {
    return 'carousel';
  } else if (launchContext === StreamsLaunchContext.ASSET_FEEDS) {
    return 'grid';
  } else if (contentView === 'details') {
    return 'list';
  } else {
    return 'grid';
  }
};
